<template>
  <div>
    <checkManagement :is-show="isShow" />
  </div>
</template>

<script>
import checkManagement from '../Finance/reconciliationManagement.vue';
export default {
  data () {
    return {
      isShow: false
    };
  },
  components: {
    checkManagement
  }
};
</script>

<style>

</style>
